// de_pms_guests.ts
// Tłumaczenia dla PMS.Guests.tsx

export const dePmsGuests = {

  title:       "Gäste",
  addGuest:    "Gast hinzufügen",
  adding:      "Hinzufügen...",
  backToGuests:"Zurück zu Gästen",

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    name:          "Vollständiger Name",
    email:         "E-Mail",
    phone:         "Telefon",
    country:       "Land",
    address:       "Adresse",
    arrivalTime:   "Ankunftszeit",
    arrival:       "Anreise",
    departure:     "Abreise",
    adultsChildren:"Erwachsene / Kinder",
    balanceDue:    "Offener Betrag",
    billingCompany:"Rechnungsfirma",
    activeFolio:   "Aktives Folio",
    actions:       "Aktionen",
  },

  // ── Walidacja ─────────────────────────────────────────────────────────────
  validation: {
    arrivalDeparture:"Anreise und Abreise müssen mindestens eine Nacht umfassen.",
  },

} as const;

export default dePmsGuests;
